'use client'

import React from 'react'

import * as UI from '@/src/features/catalog/product-list/product-list-item.styled'
import {observer} from 'mobx-react'
import {useProductListItem} from './product-list-item.provider'

export const ProductPriceContainer = observer(() => {
  const productListItemVM = useProductListItem()
  if (!productListItemVM) throw Error('Product item view model does not found in list')

  return (
    <UI.ProductPrices>
      {productListItemVM.price?.price && (
        <UI.ProductPrice>{productListItemVM.price.price_formatted}</UI.ProductPrice>
      )}
      {productListItemVM.price?.old_price &&
        productListItemVM.price.old_price != productListItemVM.price.price && (
          <UI.ProductOldPrice>{productListItemVM.price.old_price_formatted}</UI.ProductOldPrice>
        )}
    </UI.ProductPrices>
  )
})
